<template>
  <transition name="fade">
    <div class="library">
      <div class="ss-breadcrumb">
        <div class="container-hts">
          <ul class="margin-0 p-0">
            <li><router-link to="/thu-vien">Thư viện</router-link></li>
            <li>
              <router-link :to="{name: 'library', query: {lop: bookInfo.classId, mon: '0', nhom: '0', tab: typeLoading}}">
                {{ bookInfo.className }}
              </router-link>
            </li>
            <li v-if="bookInfo.subjectName && bookInfo.subjectId">
              <router-link :to="{name: 'library', query: {lop: bookInfo.classId, mon: bookInfo.subjectId, nhom: '0', tab: typeLoading}}">
                {{ bookInfo.subjectName }}
              </router-link>
            </li>
            <li v-if="bookInfo.practiceTypeName && bookInfo.practiceTypeId">
              <router-link :to="{name: 'library', query: {lop: bookInfo.classId, mon: bookInfo.subjectId, nhom: bookInfo.practiceTypeId, tab: typeLoading}}">
                {{ bookInfo.practiceTypeName }}
              </router-link>
            </li>
            <li v-if="bookInfo.bookName && (bookInfo.bookId || bookId)">
                <span>{{ bookInfo.bookName }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="ss-data">
        <div class="container-hts">
          <div class="library__wrap display-flex justify-content-between">
            <SidebarAll :bookInfo="bookInfo" />
            <div class="library__data">
              <div class="library__data__head display-flex-center justify-content-between">
              </div>
              <div class="library__list">
                <!-- data detail - {{ librariesData }} -->
                  <!-- <template v-for="(item, index) of librariesData">
                    <ItemLibrary v-if="item" :dataSource="item" :isLesson="item.bookLessonPlanTypeId ? true : false" :class="`col-12 col-sm-4 col-md-3`" />
                  </template> -->
                <b-tabs v-if="librariesData && librariesData.length > 0 && (librariesData[0].documentTypeId || librariesData[0].bookLessonPlanTypeId)">
                  <b-tab v-for="(item, index) of librariesData" :key="index" :title="item.name ? item.name : 'Video'">
                    <div class="library__list__body"></div>
                    <div class="row" v-if="(item.listBookPageLinks && item.listBookPageLinks.length > 0) || (item.listBookLessonPlans && item.listBookLessonPlans.length > 0)">
                      <template v-for="(child, pos) of item.bookLessonPlanTypeId ? item.listBookLessonPlans : item.listBookPageLinks ? item.listBookPageLinks : item.lstActiveLearning">
                        <!-- <ItemLibrary v-if="child" :dataSource="child" :isLesson="item.bookLessonPlanTypeId ? true : false" :class="`col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4`" /> -->
                        <ItemLibrary v-if="child" :dataSource="child" :isLesson="tabPagelink ? tabPagelink : tabLesson" :class="`col-12 col-sm-6 col-md-4`" />
                        
                        <!-- <ItemLibrary v-if="child" :dataSource="child" :isLesson="tabPagelink" :class="`col-12 col-sm-6 col-md-4`" /> -->
                        <!-- <ItemLibrary v-if="child" :dataSource="child" :isLesson="tabLesson" :class="`col-12 col-sm-6 col-md-4`" /> -->
                      </template>
                    </div>
                    <p v-else class="font-size-20 secondary-color-txt text-center">Dữ liệu đang được cập nhật</p>
                  </b-tab>
                </b-tabs>
                <b-tabs v-else-if="librariesData && librariesData.length > 0">
                  <b-tab title='Video'>
                      <div class="library__list__body"></div>
                      <div class="row" v-if="librariesData">
                        <template v-for="(child, pos) of librariesData">
                          <ItemLibrary v-if="child && pos < 24" :dataSource="child" :isLesson="tabActiveLearning" :class="`col-12 col-sm-6 col-md-4`" />
                        </template>
                      </div>
                      <p v-else class="font-size-20 secondary-color-txt text-center">Dữ liệu đang được cập nhật</p>
                  </b-tab>
                </b-tabs>
                <div id="library_end"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { STORE_KEY, TYPE_PAGE_LINK_LOAD, TYPE_LESSON_LOAD, TAB_MEDIA_PAGE_LINK, TAB_LESSON, TAB_ACTIVE_LEARNING } from './../_store/constants'
  import { getLessonsPlan, getMediaListInLibs, getListActiveLearningAll, getListActiveLearningHome } from './../_api/'
  import { getInfoBookBasic } from '@/modules/exercises/_api'

  export default {
    name: 'LibraryAllOfBook',
    components: {
      SidebarAll: () => import('./../_components/list/SidebarAll.vue'),
      ItemLibrary: () => import('./../_components/list/ItemLibrary.vue'),
      FilterForm: () => import('./../_components/list/FilterForm.vue')
    },
    data () {
      return {
        librariesData: [],
        bookInfo: {},
        typePageLink: TYPE_PAGE_LINK_LOAD,
        nameTypeLibCurr: '',
        tabPagelink: TAB_MEDIA_PAGE_LINK,
        tabLesson: TAB_LESSON,
        tabActiveLearning: TAB_ACTIVE_LEARNING,
        tabIndexActive: 0,
        observer: null
      }
    },
    computed: {
      ...mapState(STORE_KEY, ['paramSearchLessons', 'bookIdActiveSuccess']),
      ...mapState('auth', ['loginPopupData']),
      routerQuery() {
				return this.$route.query;
			},
      libAllId() {
        return this.$route.params.id;
      },
      typeLoading() {
        return this.$route.params.type;
      },
      bookId() {
       return this.$route.params.book;
      },
      subjectId() {
        return this.$route.params.subjectId;
      }
    },
    watch: {
      'paramSearchLessons': 'getLibsData',
      // bookIdActiveSuccess(newVal) {
      //  if(newVal && newVal === this.bookId) {
      //    this.fetchBookInfo();
      //  }
      // },
      loginPopupData(newVal) {
        newVal && Object.keys(newVal).length && this.fetchBookInfo();
      }
    },
    created() {
      this.initParamsSearch();
    },
    mounted() {
      this.elmEndItem = document.getElementById('library_end')
      this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
      this.observer.observe(this.elmEndItem)
    },
    beforeDestroy () {
      this.setParamSearchLesson({...this.paramSearchLessons, subjectId: 0, bookId: 0, documentTypeId: 0, pageIndex: 1});
      this.observer.unobserve(this.elmEndItem);
    },
    methods: {
      ...mapActions('common', ['setLoading']),
      ...mapActions(STORE_KEY, ['setParamSearchLesson']),

      initParamsSearch() {
        // this.setLoading(true)
        this.fetchBookInfo();
        this.setParamSearchLesson({...this.paramSearchLessons, subjectId: this.subjectId, bookId: this.bookId});
      },

      fetchBookInfo() {
        let self = this;
        self.bookId && getInfoBookBasic(self.bookId).then(res => {
          if(res && res.data && !res.errors) {
            self.bookInfo = res.data;
          }
        })
      },

      getLibsData() {
        let self = this;
        // self.setLoading(true)
        if(parseInt(self.typeLoading) === TAB_MEDIA_PAGE_LINK) {
          getMediaListInLibs(self.paramSearchLessons).then(res => {
            res && res.data && res.data.list && !res.errors && self.setLibsDataRender(res.data.list)
          }).finally(() => self.setLoading(false));
        } else if (parseInt(self.typeLoading) === TAB_LESSON){
          getLessonsPlan(self.paramSearchLessons).then(res => {
            res && res.data && res.data.list && !res.errors && self.setLibsDataRender(res.data.list)
          }).finally(() => self.setLoading(false));
        } else {
          getListActiveLearningAll(self.paramSearchLessons).then(res => {
            if(res && res.data && res.data.list && !res.errors) {
              self.librariesData = res.data.list
            }
          }).finally(() => self.setLoading(false));
        }
      },

      setLibsDataRender (data) {
        if (!this.paramSearchLessons.documentTypeId || this.paramSearchLessons.documentTypeId === 0 || this.librariesData.length === 0) {
          this.librariesData = data
        } else if (data.length > 0 && data[0].listBookPageLinks) {
          this.librariesData[this.tabIndexActive].listBookPageLinks = [...this.librariesData[this.tabIndexActive].listBookPageLinks, ...data[0].listBookPageLinks]
          this.librariesData[this.tabIndexActive].paging = data[0].paging
          // console.log('Push data for tab', this.librariesData[this.tabIndexActive].listBookPageLinks)
        }
      },

      onChangeTab (index) {
        this.tabIndexActive = index
      },

      handleScrollEnd () {
        let pagingActive = this.librariesData && this.librariesData[this.tabIndexActive] ? this.librariesData[this.tabIndexActive].paging : null;
        if (!pagingActive || !pagingActive.totalPage || pagingActive.totalPage < 2 || (pagingActive && pagingActive.totalPage <= pagingActive.pageIndex)) {
          return
        }
       
        if(parseInt(this.typeLoading) === TAB_MEDIA_PAGE_LINK) {
          const documentId = this.librariesData[this.tabIndexActive].documentTypeId
          this.setParamSearchLesson({...this.paramSearchLessons, documentTypeId: documentId, pageIndex: pagingActive.pageIndex + 1, bookLessonPlanTypeId: 0})
        } else if(parseInt(this.typeLoading) === TAB_LESSON){
          const bookLessonPlanTypeId = this.librariesData[this.tabIndexActive].bookLessonPlanTypeId
          this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId, pageIndex: pagingActive.pageIndex + 1, documentTypeId: 0 })
        } else if(parseInt(this.typeLoading) === TAB_ACTIVE_LEARNING){
          const activeLearningId = this.librariesData[this.tabIndexActive].activeLearningId
          this.setParamSearchLesson({...this.paramSearchLessons, activeLearningId, pageIndex: pagingActive.pageIndex + 1, documentTypeId: 0 })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../../assets/scss/variables";
  @import "./../../../assets/scss/mixins";
  @import "./../../../assets/scss/general";

  .collapse-subject{
    .subject-list{
      padding-left: 18px;
      margin-top: 6px;
    }
  }

  .library {
    &__search {
      margin-bottom: 35px;
    }

    &__sidebar {
      width: 27%;
      margin-right: 5%;
      padding-top: 8px;

      ul {
        li {
          min-height: 36px;
          padding: 5px 18px;
          @extend .border-rd-8;
          margin-bottom: 2px;
          @extend .list-style-none;
          @extend .display-flex-center;
          .subject-cl{
            @extend .primary-color-txt;
          }
          a {
            @extend .secondary-color-txt;
            @extend .font-size-16;
          }

          &.active, &:hover {
            background: $btn_hover_color;

            >a {
              @extend .primary-color;
              @extend .font-sanpro-semibold;
            }
          }
        }
      }
      .form-active{
        margin-top: 20px;
      }
    }

    &__data {
      width: 63%;

      &__head {
        border-bottom: 1px solid $color_border_main;

        .btn-collapse {
          line-height: 1.3;
          color: $primary_color;
          letter-spacing: 0.03em;

          i {
            margin-left: 6px;
          }
        }
      }
    }

    &__list {
      padding-top: 20px;

      &__body {
        margin-top: 20px;
      }
    }

    &__tabs {
      &__content {
        padding: 35px 0 20px;
      }
    }

    @media screen and ( max-width: 991px ) {
      &__wrap {
        display: block;
      }

      &__sidebar, &__data {
        width: 100%;
      }
      &__sidebar {
        margin-bottom: 30px;
      }
    }
  }
  #collapse_filter {
    border-bottom: 1px solid $color_border_main;
  }
</style>

